(function () {


  /* ==================================================
     DETECT PWA
     ================================================== */

  const standalone =
    window
      .matchMedia(
        '(display-mode: standalone)'
      )
      .matches
    ||
    window.navigator.standalone === true;


  /* ==================================================
     PREVIEW
     ?pwa-nav-preview=1
     ================================================== */

  const params =
    new URLSearchParams(
      window.location.search
    );


  const preview =
    params.get(
      'pwa-nav-preview'
    ) === '1';


  if (
    standalone ||
    preview
  ) {

    document
      .documentElement
      .classList
      .add(
        'hlp-pwa-mode'
      );

  }


  /* ==================================================
     HOMEPAGE HERO / PWA NAV
     Hide while hero is visible.
     Show after hero has passed.
     ================================================== */

  let hlpHomeHeroObserver =
    null;


  function hlpSyncHomeHeroNav(
    hero
  ) {

    const root =
      document.documentElement;


    if (!hero) {

      root.classList.add(
        'hlp-home-hero-passed'
      );

      return;

    }


    const rect =
      hero.getBoundingClientRect();


    const heroPassed =
      rect.bottom <= 0;


    root.classList.toggle(
      'hlp-home-hero-passed',
      heroPassed
    );

  }


  function hlpInitHomeHeroNav() {

    const root =
      document.documentElement;


    const homeNav =
      document.querySelector(
        '.hlp-pwa-nav--home'
      );


    /*
     * Only applies to homepage
     * when PWA mode is active.
     */

    if (
      !root.classList.contains(
        'hlp-pwa-mode'
      )
      ||
      !homeNav
    ) {

      root.classList.remove(
        'hlp-home-hero-passed'
      );

      return;

    }


    const hero =
      document.querySelector(
        '.hlp-home-hero'
      );


    /*
     * Safety fallback:
     * if the homepage hero is missing,
     * show navigation normally.
     */

    if (!hero) {

      root.classList.add(
        'hlp-home-hero-passed'
      );

      return;

    }


    /*
     * Disconnect previous observer.
     */

    if (hlpHomeHeroObserver) {

      hlpHomeHeroObserver
        .disconnect();

      hlpHomeHeroObserver =
        null;

    }


    /*
     * Set correct state immediately.
     */

    hlpSyncHomeHeroNav(
      hero
    );


    /*
     * Watch the homepage hero.
     */

    hlpHomeHeroObserver =
      new IntersectionObserver(
        function () {

          hlpSyncHomeHeroNav(
            hero
          );

        },
        {
          root: null,
          threshold: 0
        }
      );


    hlpHomeHeroObserver.observe(
      hero
    );

  }


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      hlpInitHomeHeroNav,
      {
        once: true
      }
    );

  } else {

    hlpInitHomeHeroNav();

  }


  document.addEventListener(
    'shopify:section:load',
    function () {

      window.setTimeout(
        hlpInitHomeHeroNav,
        0
      );

    }
  );


  document.addEventListener(
    'shopify:section:unload',
    function () {

      window.setTimeout(
        hlpInitHomeHeroNav,
        0
      );

    }
  );


  /* ==================================================
     HAPPY LITTLE PAWS
     PWA CART COUNT SYNC V3
     Shopify Cart + Drawer + PWA + Page Restore
     ================================================== */

  /* The version marker makes it possible to confirm that
     the current PWA is actually running this updated code. */
  document.documentElement.dataset.hlpPwaCartSync = 'v3';

  const HLP_CART_BADGE_SELECTOR = '[data-hlp-cart-count]';

  let hlpCartCountTimer = null;
  let hlpCartRequestId = 0;
  let hlpCartActionTimers = [];

  /* --------------------------------------------------
     RENDER BADGE
     -------------------------------------------------- */

  function hlpPaintCartCount(value) {
    const badge = document.querySelector(HLP_CART_BADGE_SELECTOR);
    if (!badge) return;

    const count = Math.max(0, Math.floor(Number(value) || 0));

    badge.textContent = count > 99 ? '99+' : String(count);
    badge.classList.toggle('is-hidden', count === 0);
  }

  /* --------------------------------------------------
     GET THE ACTUAL CART FROM SHOPIFY
     -------------------------------------------------- */

  async function hlpUpdateCartCount() {
    if (!document.querySelector(HLP_CART_BADGE_SELECTOR)) return;

    const requestId = ++hlpCartRequestId;
    const root = window.Shopify?.routes?.root || '/';
    const cartUrl = root + 'cart.js?hlp_sync=' + Date.now();

    try {
      const response = await fetch(cartUrl, {
        method: 'GET',
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { Accept: 'application/json' }
      });

      if (!response.ok) {
        throw new Error('Cart returned HTTP ' + response.status);
      }

      const cart = await response.json();

      // Older requests must not override a newer count.
      if (requestId !== hlpCartRequestId) return;

      hlpPaintCartCount(cart.item_count);
    } catch (error) {
      console.debug('HLP PWA cart count sync failed:', error);
    }
  }

  /* --------------------------------------------------
     GROUP QUICK REPEATED EVENTS
     -------------------------------------------------- */

  function hlpQueueCartCountSync(delay = 120) {
    window.clearTimeout(hlpCartCountTimer);
    hlpCartCountTimer = window.setTimeout(hlpUpdateCartCount, delay);
  }

  /* This fallback is useful for custom cart scripts which
     do not publish Shopify/Dawn cart update events. */
  function hlpCartActionFallback() {
    hlpCartActionTimers.forEach(window.clearTimeout);
    hlpCartActionTimers = [
      window.setTimeout(function () {
        hlpQueueCartCountSync(0);
      }, 450),
      window.setTimeout(function () {
        hlpQueueCartCountSync(0);
      }, 1400)
    ];
  }

  /* --------------------------------------------------
     SHOPIFY / DAWN CART UPDATE EVENTS
     -------------------------------------------------- */

  function hlpHandleDawnCartUpdate(event) {
    if (event && event.cartData &&
        typeof event.cartData.item_count !== 'undefined') {
      ++hlpCartRequestId;
      hlpPaintCartCount(event.cartData.item_count);
    }

    // Verify with Shopify in case another app changed the cart.
    hlpQueueCartCountSync(100);
  }

  /* --------------------------------------------------
     WATCH CART PAGE CONTENT
     -------------------------------------------------- */

  function hlpWatchCartPage() {
    const cartArea = document.querySelector('#main-cart-items') ||
                     document.querySelector('cart-items');

    if (!cartArea) return;

    const observer = new MutationObserver(function () {
      hlpQueueCartCountSync(160);
    });

    observer.observe(cartArea, {
      childList: true,
      characterData: true,
      subtree: true
    });
  }

  /* --------------------------------------------------
     WATCH SUCCESSFUL CART AJAX WRITES

     This covers cart removal, quantity updates, add, and
     clear even if a custom app skips Dawn's event system.
     Keep the original fetch Promise/Response unchanged.
     -------------------------------------------------- */

  function hlpWatchCartRequests() {
    if (window.__hlpPwaCartFetchHooked) return;
    if (typeof window.fetch !== 'function') return;

    const originalFetch = window.fetch;

    window.fetch = function () {
      const input = arguments[0];
      const result = originalFetch.apply(this, arguments);

      try {
        const address = typeof input === 'string'
          ? input
          : input instanceof URL
            ? input.href
            : input && input.url;

        if (address) {
          const url = new URL(address, window.location.href);
          const isCartWrite =
            url.origin === window.location.origin &&
            /\/cart\/(?:add|change|update|clear)(?:\.js)?\/?$/.test(url.pathname);

          if (isCartWrite) {
            Promise.resolve(result)
              .then(function (response) {
                if (response && response.ok) {
                  hlpQueueCartCountSync(80);
                  // One follow-up for slower Shopify/cart app updates.
                  window.setTimeout(function () {
                    hlpQueueCartCountSync(0);
                  }, 500);
                }
              })
              .catch(function () {
                // The caller receives the original fetch error.
              });
          }
        }
      } catch (error) {
        // Never interfere with other storefront requests.
      }

      return result;
    };

    window.__hlpPwaCartFetchHooked = true;
  }

  /* --------------------------------------------------
     CART PAGE FALLBACK FOR REMOVE / QUANTITY CLICKS
     -------------------------------------------------- */

  document.addEventListener('click', function (event) {
    if (!document.querySelector('cart-items')) return;
    if (!event.target || !event.target.closest) return;

    const target = event.target.closest(
      'cart-remove-button, .cart-remove-button, ' +
      '.quantity__button, [data-cart-remove], [data-cart-quantity]'
    );

    if (target) hlpCartActionFallback();
  }, true);

  document.addEventListener('change', function (event) {
    if (!document.querySelector('cart-items')) return;
    if (!event.target || !event.target.matches) return;

    if (event.target.matches(
      'input[name="updates[]"], .quantity__input'
    )) {
      hlpCartActionFallback();
    }
  }, true);

  /* --------------------------------------------------
     CART ADD FORM FALLBACK
     -------------------------------------------------- */

  document.addEventListener('submit', function (event) {
    if (!event.target || !event.target.closest) return;

    const form = event.target.closest('form[action*="/cart/add"]');
    if (form) hlpCartActionFallback();
  }, true);

  /* --------------------------------------------------
     CUSTOM EVENT FALLBACKS
     -------------------------------------------------- */

  document.addEventListener('cart:updated', function () {
    hlpQueueCartCountSync(80);
  });

  document.addEventListener('cart:refresh', function () {
    hlpQueueCartCountSync(80);
  });

  /* --------------------------------------------------
     PWA / BACK-FORWARD RESTORE
     -------------------------------------------------- */

  window.addEventListener('pageshow', function () {
    hlpQueueCartCountSync(80);
  });

  window.addEventListener('popstate', function () {
    hlpQueueCartCountSync(80);
  });

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') {
      hlpQueueCartCountSync(80);
    }
  });

  /* --------------------------------------------------
     INITIALIZE AFTER DOM IS READY
     -------------------------------------------------- */

  function hlpInitCartCountSync() {
    hlpUpdateCartCount();
    hlpWatchCartPage();
    hlpWatchCartRequests();

    if (typeof subscribe === 'function' &&
        typeof PUB_SUB_EVENTS !== 'undefined' &&
        PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, hlpHandleDawnCartUpdate);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      hlpInitCartCountSync,
      { once: true }
    );
  } else {
    hlpInitCartCountSync();
  }


  /* ==================================================
     CATEGORY ELEMENTS
     ================================================== */

  const hlpCatTrigger =
    document.querySelector(
      '[data-hlp-categories-trigger]'
    );


  const hlpCatSheet =
    document.querySelector(
      '[data-hlp-cat-sheet]'
    );


  const hlpCatBackdrop =
    document.querySelector(
      '[data-hlp-cat-backdrop]'
    );


  const hlpCatClose =
    document.querySelector(
      '[data-hlp-cat-close]'
    );


  /* ==================================================
     OPEN CATEGORY SHEET
     ================================================== */

  function hlpOpenCategorySheet() {

    if (
      !hlpCatTrigger ||
      !hlpCatSheet
    ) {
      return;
    }


    if (
      document
        .documentElement
        .classList
        .contains(
          'hlp-filter-open'
        )
      ||
      document
        .documentElement
        .classList
        .contains(
          'hlp-menu-open'
        )
    ) {
      return;
    }


    document
      .documentElement
      .classList
      .add(
        'hlp-category-sheet-open'
      );


    hlpCatTrigger.setAttribute(
      'aria-expanded',
      'true'
    );


    hlpCatSheet.setAttribute(
      'aria-hidden',
      'false'
    );


    if (hlpCatBackdrop) {

      hlpCatBackdrop.setAttribute(
        'aria-hidden',
        'false'
      );

    }


    window.setTimeout(
      function () {

        if (hlpCatClose) {
          hlpCatClose.focus();
        }

      },
      120
    );

  }


  /* ==================================================
     CLOSE CATEGORY SHEET
     ================================================== */

  function hlpCloseCategorySheet(
    restoreFocus
  ) {

    document
      .documentElement
      .classList
      .remove(
        'hlp-category-sheet-open'
      );


    if (hlpCatTrigger) {

      hlpCatTrigger.setAttribute(
        'aria-expanded',
        'false'
      );

    }


    if (hlpCatSheet) {

      hlpCatSheet.setAttribute(
        'aria-hidden',
        'true'
      );

    }


    if (hlpCatBackdrop) {

      hlpCatBackdrop.setAttribute(
        'aria-hidden',
        'true'
      );

    }


    if (
      restoreFocus &&
      hlpCatTrigger
    ) {

      window.setTimeout(
        function () {

          hlpCatTrigger.focus();

        },
        50
      );

    }

  }


  /* ==================================================
     PWA CART DRAWER
     Opens Dawn Cart Drawer
     Keeps /cart as fallback
     ================================================== */

  const hlpCartTrigger =
    document.querySelector(
      '[data-hlp-cart-trigger]'
    );


  if (hlpCartTrigger) {

    hlpCartTrigger.addEventListener(
      'click',
      function (event) {

        const cartDrawer =
          document.querySelector(
            'cart-drawer'
          );


        if (
          !cartDrawer ||
          typeof cartDrawer.open !==
            'function'
        ) {
          return;
        }


        event.preventDefault();


        hlpCloseCategorySheet(
          false
        );


        cartDrawer.open(
          hlpCartTrigger
        );

      }
    );

  }


  /* ==================================================
     CATEGORY BUTTON
     ================================================== */

  if (hlpCatTrigger) {

    hlpCatTrigger.addEventListener(
      'click',
      function () {

        const isOpen =
          document
            .documentElement
            .classList
            .contains(
              'hlp-category-sheet-open'
            );


        if (isOpen) {

          hlpCloseCategorySheet(
            false
          );

        } else {

          hlpOpenCategorySheet();

        }

      }
    );

  }


  /* ==================================================
     BACKDROP
     ================================================== */

  if (hlpCatBackdrop) {

    hlpCatBackdrop.addEventListener(
      'click',
      function () {

        hlpCloseCategorySheet(
          false
        );

      }
    );

  }


  /* ==================================================
     CLOSE BUTTON
     ================================================== */

  if (hlpCatClose) {

    hlpCatClose.addEventListener(
      'click',
      function () {

        hlpCloseCategorySheet(
          true
        );

      }
    );

  }


  /* ==================================================
     CATEGORY LINKS
     ================================================== */

  if (hlpCatSheet) {

    hlpCatSheet
      .querySelectorAll('a')
      .forEach(
        function (link) {

          link.addEventListener(
            'click',
            function () {

              hlpCloseCategorySheet(
                false
              );

            }
          );

        }
      );

  }


  /* ==================================================
     OTHER NAV ITEMS
     ================================================== */

  document
    .querySelectorAll(
      '.hlp-pwa-nav__item:not([data-hlp-categories-trigger])'
    )
    .forEach(
      function (item) {

        item.addEventListener(
          'click',
          function () {

            hlpCloseCategorySheet(
              false
            );

          }
        );

      }
    );


  /* ==================================================
     KEYBOARD
     ================================================== */

  document.addEventListener(
    'keydown',
    function (event) {

      const isSheetOpen =
        document
          .documentElement
          .classList
          .contains(
            'hlp-category-sheet-open'
          );


      if (!isSheetOpen) {
        return;
      }


      if (
        event.key ===
        'Escape'
      ) {

        event.preventDefault();

        hlpCloseCategorySheet(
          true
        );

        return;
      }


      if (
        event.key ===
        'Tab'
        &&
        hlpCatSheet
      ) {

        const focusable =
          Array.from(
            hlpCatSheet.querySelectorAll(
              'a[href], button:not([disabled])'
            )
          );


        if (!focusable.length) {
          return;
        }


        const first =
          focusable[0];


        const last =
          focusable[
            focusable.length - 1
          ];


        if (
          event.shiftKey
          &&
          document.activeElement ===
            first
        ) {

          event.preventDefault();

          last.focus();

        } else if (
          !event.shiftKey
          &&
          document.activeElement ===
            last
        ) {

          event.preventDefault();

          first.focus();

        }

      }

    }
  );


  /* ==================================================
     HAMBURGER STATE
     ================================================== */

  function hlpSyncMenuState() {

    const menuIsOpen =
      Boolean(
        document.querySelector(
          'header-drawer details[open], ' +
          '#Details-menu-drawer-container[open], ' +
          'details.menu-drawer-container[open], ' +
          '.menu-drawer-container[open], ' +
          '.menu-drawer-container.menu-opening, ' +
          '.menu-drawer[open]'
        )
      );


    if (menuIsOpen) {

      hlpCloseCategorySheet(
        false
      );

    }


    document
      .documentElement
      .classList
      .toggle(
        'hlp-menu-open',
        menuIsOpen
      );

  }


  /* ==================================================
     MOBILE FILTER STATE
     ================================================== */

  function hlpSyncFilterState() {

    const filterIsOpen =
      Boolean(
        document.querySelector(
          '.mobile-facets__wrapper details[open], ' +
          '.mobile-facets__wrapper details.menu-opening, ' +
          'details.mobile-facets__disclosure[open], ' +
          '.mobile-facets__disclosure[open]'
        )
      );


    if (filterIsOpen) {

      hlpCloseCategorySheet(
        false
      );

    }


    document
      .documentElement
      .classList
      .toggle(
        'hlp-filter-open',
        filterIsOpen
      );

  }


  /* ==================================================
     WATCH HAMBURGER
     ================================================== */

  const hlpMenuObserver =
    new MutationObserver(
      function () {

        hlpSyncMenuState();

      }
    );


  document
    .querySelectorAll(
      'header-drawer details, ' +
      '#Details-menu-drawer-container, ' +
      '.menu-drawer-container'
    )
    .forEach(
      function (element) {

        hlpMenuObserver.observe(
          element,
          {
            attributes: true,

            attributeFilter:
              [
                'open',
                'class'
              ]
          }
        );

      }
    );


  /* ==================================================
     WATCH MOBILE FILTER
     ================================================== */

  const hlpFilterObserver =
    new MutationObserver(
      function () {

        hlpSyncFilterState();

      }
    );


  function hlpObserveFilters() {

    document
      .querySelectorAll(
        '.mobile-facets__wrapper details, ' +
        'details.mobile-facets__disclosure, ' +
        '.mobile-facets__disclosure'
      )
      .forEach(
        function (element) {

          if (
            element.dataset
              .hlpFilterObserved ===
            'true'
          ) {
            return;
          }


          element.dataset
            .hlpFilterObserved =
            'true';


          hlpFilterObserver.observe(
            element,
            {
              attributes: true,

              attributeFilter:
                [
                  'open',
                  'class'
                ]
            }
          );

        }
      );

  }


  hlpObserveFilters();


  /* ==================================================
     FILTER DOM FALLBACK
     ================================================== */

  const hlpDocumentObserver =
    new MutationObserver(
      function () {

        hlpObserveFilters();

        hlpSyncFilterState();

      }
    );


  hlpDocumentObserver.observe(
    document.body,
    {
      childList: true,
      subtree: true
    }
  );


  /* ==================================================
     CLICK FALLBACK
     ================================================== */

  document.addEventListener(
    'click',
    function () {

      window.setTimeout(
        function () {

          hlpSyncMenuState();

          hlpSyncFilterState();

        },
        30
      );

    },
    true
  );


  /* ==================================================
     INITIAL STATES
     ================================================== */

  hlpSyncMenuState();

  hlpSyncFilterState();


})();
